/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetServerClockRow } from '../openapi-types.gen.js';
import { type useGetServerClockArgs, useGetServerClockSpec } from '../specs/system.spec.gen.js';

export type { GetServerClockRow } from '../openapi-types.gen.js';
export type { useGetServerClockArgs } from '../specs/system.spec.gen.js';


const _useGetServerClock = createHook(useGetServerClockSpec);
export const useGetServerClock = _useGetServerClock as (args: useGetServerClockArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetServerClock>;


/**
 * Hover/intent prefetch companion for `useGetServerClock`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetServerClock();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetServerClock = createPrefetchHook(useGetServerClockSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetServerClockArgs>;
